import { appConstants } from "../../constants/appconstants";
import { getApiCall, postApiCall } from "../../utils/ApiMethods";

const FetchSmartCubePageFilterAction = (l1Category, l2Category) => {
    return async function (dispatch) {
        dispatch({ type: 'LOADING_SMARTCUBE_PAGE_FILTER_ACTION' });
        try {
            const data = await getApiCall(`${appConstants.BASE_URL}/smartcube/get-filters?l1Category=${encodeURIComponent(l1Category)}&l2Category=${encodeURIComponent(l2Category)}`);
            const temp = {
    "sector": [
        {
            "name": "APAC",
            "categories": [
                "Wheat"
            ]
        },
        {
            "name": "EMEA",
            "categories": [
                "Wheat"
            ]
        },
        {
            "name": "Europe",
            "categories": [
                "Wheat"
            ]
        },
        {
            "name": "Global",
            "categories": [
                "Rye",
                "Sorghum",
                "Wheat"
            ]
        },
        {
            "name": "LATAM",
            "categories": [
                "Wheat"
            ]
        },
        {
            "name": "North America",
            "categories": [
                "Wheat"
            ]
        }
    ],
    "dateInfo": {
        "maxDate": "2026-07-01",
        "maxYearMonth": "Jul 26",
        "minDate": "2023-01-01",
        "minYearMonth": "Jan 23",
        "defaultMax": "Jul 26",
        "defaultMin": "Jul 24"
    }
}
            var resData = Object.assign({ type: 'SUCCESS_SMARTCUBE_PAGE_FILTER_ACTION' }, data);
            // var resData = Object.assign({ type: 'SUCCESS_SMARTCUBE_PAGE_FILTER_ACTION' }, temp);
            dispatch(resData);
        } catch (error) {
            dispatch({ type: 'ERROR_SMARTCUBE_PAGE_FILTER_ACTION', error });
        }
    };
};

const FetchSmartCubeChartFiltersAction = (payload = {}) => {
    return async function (dispatch) {
        dispatch({ type: 'LOADING_SMARTCUBE_CHART_FILTERS_ACTION' });
        try {
            const data = await postApiCall(`${appConstants.BASE_URL}/smartcube/chart-filters`, payload);
            var resData = Object.assign({ type: 'SUCCESS_SMARTCUBE_CHART_FILTERS_ACTION' }, data);
            dispatch(resData);
        } catch (error) {
            dispatch({ type: 'ERROR_SMARTCUBE_CHART_FILTERS_ACTION', error });
        }
    };
};

const FetchSmartCubeMarketSizeForecastAction = (payload = {}) => {
    return async function (dispatch) {
        dispatch({ type: 'LOADING_SMARTCUBE_MARKET_SIZE_FORECAST_ACTION' });
        try {
            const data = await postApiCall(`${appConstants.BASE_URL}/smartcube/market-size-forecast`, payload);
            var resData = Object.assign({ type: 'SUCCESS_SMARTCUBE_MARKET_SIZE_FORECAST_ACTION' }, data);
            dispatch(resData);
        } catch (error) {
            dispatch({ type: 'ERROR_SMARTCUBE_MARKET_SIZE_FORECAST_ACTION', error });
        }
    };
};

const FetchSmartCubeCategoryRiskAction = (payload = {}) => {
    return async function (dispatch) {
        dispatch({ type: 'LOADING_SMARTCUBE_CATEGORY_RISK_ACTION' });
        try {
            const data = await postApiCall(`${appConstants.BASE_URL}/smartcube/category-risk`, payload);
            var resData = Object.assign({ type: 'SUCCESS_SMARTCUBE_CATEGORY_RISK_ACTION' }, data);
            dispatch(resData);
        } catch (error) {
            dispatch({ type: 'ERROR_SMARTCUBE_CATEGORY_RISK_ACTION', error });
        }
    };
};

const FetchSmartCubeTextWidgetsAction = (payload = {}) => {
    return async function (dispatch) {
        dispatch({ type: 'LOADING_SMARTCUBE_TEXT_WIDGETS_ACTION' });
        try {
            const data = await postApiCall(`${appConstants.BASE_URL}/smartcube/text-widgets`, payload);
            var resData = Object.assign({ type: 'SUCCESS_SMARTCUBE_TEXT_WIDGETS_ACTION' }, data);
            dispatch(resData);
        } catch (error) {
            dispatch({ type: 'ERROR_SMARTCUBE_TEXT_WIDGETS_ACTION', error });
        }
    };
};

const FetchSmartCubePriceTrendAction = (payload = {}) => {
    return async function (dispatch) {
        dispatch({ type: 'LOADING_SMARTCUBE_PRICE_TREND_ACTION' });
        try {
            const data = await postApiCall(`${appConstants.BASE_URL}/smartcube/price-trend`, payload);
            var resData = Object.assign({ type: 'SUCCESS_SMARTCUBE_PRICE_TREND_ACTION' }, data);
            dispatch(resData);
        } catch (error) {
            dispatch({ type: 'ERROR_SMARTCUBE_PRICE_TREND_ACTION', error });
        }
    };
};

const FetchSmartCubeCostDriversAction = (payload = {}) => {
    return async function (dispatch) {
        dispatch({ type: 'LOADING_SMARTCUBE_COST_DRIVERS_ACTION' });
        try {
            const data = await postApiCall(`${appConstants.BASE_URL}/smartcube/cost-drivers`, payload);
            var resData = Object.assign({ type: 'SUCCESS_SMARTCUBE_COST_DRIVERS_ACTION' }, data);
            dispatch(resData);
        } catch (error) {
            dispatch({ type: 'ERROR_SMARTCUBE_COST_DRIVERS_ACTION', error });
        }
    };
};

const FetchSmartCubeCostStructureBreakdownAction = (payload = {}) => {
    return async function (dispatch) {
        dispatch({ type: 'LOADING_SMARTCUBE_COST_STRUCTURE_BREAKDOWN_ACTION' });
        try {
            const data = await postApiCall(`${appConstants.BASE_URL}/smartcube/cost-structure-breakdown`, payload);
            var resData = Object.assign({ type: 'SUCCESS_SMARTCUBE_COST_STRUCTURE_BREAKDOWN_ACTION' }, data);
            dispatch(resData);
        } catch (error) {
            dispatch({ type: 'ERROR_SMARTCUBE_COST_STRUCTURE_BREAKDOWN_ACTION', error });
        }
    };
};

export {
    FetchSmartCubePageFilterAction,
    FetchSmartCubeChartFiltersAction,
    FetchSmartCubeMarketSizeForecastAction,
    FetchSmartCubeCategoryRiskAction,
    FetchSmartCubeTextWidgetsAction,
    FetchSmartCubePriceTrendAction,
    FetchSmartCubeCostDriversAction,
    FetchSmartCubeCostStructureBreakdownAction
};
